import { render, staticRenderFns } from "./EditBoccoChannelModal.vue?vue&type=template&id=1bdd9ad6&scoped=true&"
import script from "./EditBoccoChannelModal.vue?vue&type=script&lang=ts&"
export * from "./EditBoccoChannelModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditBoccoChannelModal.vue?vue&type=style&index=0&id=1bdd9ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdd9ad6",
  null
  
)

export default component.exports